import { c as _c } from "react/compiler-runtime";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { queryClient } from "@/clients/queryClient";
import { BaseLayout } from "@/lib/components/layouts/BaseLayout";
import { trpc } from "@/router";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/upplevelser")({
  // Child routes read experiences.public for everyone. experiences.all is
  // admin-only, so prefetching it for a signed-in visitor would reject.
  loader: async () => {
    await Promise.all([queryClient.ensureQueryData(trpc.experiences.categories.all.queryOptions()), queryClient.ensureQueryData(trpc.experiences.public.queryOptions({}))]);
  },
  component: PublicLayout
});
function PublicLayout() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(BaseLayout, {
      headerMode: "full",
      showFooter: true,
      transparentHeader: true,
      children: /*#__PURE__*/_jsx(Outlet, {})
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}